import { createFileRoute } from '@tanstack/react-router'
import { MigrationsPanel } from '@/pages/admin/SystemTab'

export const Route = createFileRoute('/_authenticated/admin/system/migrations')({
  component: MigrationsPanel,
})
